import authService from '../api-authorization/AuthorizeService'
//import * as XLSX from 'xlsx/xlsx.mjs';
import * as XLSX from 'xlsx-js-style';

export default class ReporteDespachoService {
    async ReporteDespacho(year, week, destinos) {
        const token = await authService.getAccessToken();
        var queryString = '?year=' + year + '&week=' + week + '&destinos=' + destinos;
        const reporteResponse = await fetch('api/ReporteDespacho/ExcelData' + queryString, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
        });
        const rows = await reporteResponse.json();
        rows.forEach(row => {
            // Iterate through each key (column) in the row object
            for (let key in row) {
                if (row.hasOwnProperty(key)) {
                    // If the value is 0, replace it with an empty string
                    if (row[key] === 0) {
                        row[key] = "";
                    }
                }
            }
        });

        var semanaResponse = await fetch('api/semanas?year=' + year + '&week=' + week, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const semanas = await semanaResponse.json();
        const semana = semanas.find(x => x.year == year && x.week == week);
        /* generate worksheet and workbook */
        const worksheet = XLSX.utils.json_to_sheet(rows, { origin: "A3", skipHeader: true });
        /*        worksheet['!autofilter'] = { ref: "A1:D4" };*/
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Foglio1");

        const columns = [
            "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z",
            "AA", "AB", "AC", "AD", "AE", "AF", "AG", "AH", "AI", "AJ", "AK", "AL", "AM", "AN", "AO", "AP", "AQ", "AR", "AS", "AT", "AU", "AV", "AW", "AX", "AY", "AZ",
            "BA", "BB", "BC", "BD", "BE", "BF", "BG", "BH", "BI", "BJ"
        ]
       
        var style_h1 = {
            fill: { fgColor: { rgb: "FFFF00" } },
            alignment: {horizontal: "center", vertical: "top"},
            font: {
                name: 'Calibri',
                sz: 11,
                //color: { rgb: "#FF000000" },
                bold: true,
                italic: false,
                underline: false,
            },
            border: {
                top: { style: "thin", color: { auto: 1 } },
                right: { style: "thin", color: { auto: 1 } },
                bottom: { style: "thin", color: { auto: 1 } },
                left: { style: "thin", color: { auto: 1 } }
            }
        }
        var style_h2 = {
            fill: { fgColor: { rgb: "FFF2CC" } },
            alignment: {horizontal: "center", vertical: "top"},
            font: {
                name: 'Calibri',
                sz: 11,
                //color: { rgb: "#FF000000" },
                bold: true,
                italic: false,
                underline: false,
            },
            border: {
                top: { style: "thin", color: { auto: 1 } },
                right: { style: "thin", color: { auto: 1 } },
                bottom: { style: "thin", color: { auto: 1 } },
                left: { style: "thin", color: { auto: 1 } }
            }
        }
        var style_h3 = {
            fill: { fgColor: { rgb: "DDEBF7" } },
            alignment: { horizontal: "center", vertical: "top" },
            font: {
                name: 'Calibri',
                sz: 11,
                //color: { rgb: "#FF000000" },
                bold: true,
                italic: false,
                underline: false,
            },
            border: {
                top: { style: "thin", color: { auto: 1 } },
                right: { style: "thin", color: { auto: 1 } },
                bottom: { style: "thin", color: { auto: 1 } },
                left: { style: "thin", color: { auto: 1 } }
            }
        }
        var style_h4 = {
            alignment: { horizontal: "center", vertical: "top" },
            font: {
                name: 'Calibri',
                sz: 11,
                //color: { rgb: "#FF000000" },
                bold: true,
                italic: true,
                underline: false,
            },
            border: {
                top: { style: "thin", color: { auto: 1 } },
                right: { style: "thin", color: { auto: 1 } },
                bottom: { style: "thin", color: { auto: 1 } },
                left: { style: "thin", color: { auto: 1 } }
            }
        }
        var style_default = {
            alignment: { horizontal: "center", vertical: "top" },
            font: {
                name: 'Calibri',
                sz: 11,
                //color: { rgb: "#FF000000" },
                bold: true,
                italic: false,
                underline: false,
            },
            border: {
                top: { style: "thin", color: { auto: 1 } },
                right: { style: "thin", color: { auto: 1 } },
                bottom: { style: "thin", color: { auto: 1 } },
                left: { style: "thin", color: { auto: 1 } }
            }
        }

        /* fix headers */
        XLSX.utils.sheet_add_aoa(worksheet, [["", "", "", "",
            "STD 5", "", "", "", "", "", "", "", "STD 6", "", "", "", "", "", "", "", "STD 7", "", "", "", "", "STD 8", "", "", "", "", "STD 9", "", "", "", "", "STD 10", "", "", "", "",
            "CRW 5", "", "", "", "CRW 6", "", "", "CRW 7", "", "", "CRW 8", "", "", "CRW 9", "", "", "CRW 10", "", ""
        ]], { origin: "A1" });

        const adjustedMerges = [
            { s: { r: 0, c: 4 }, e: { r: 0, c: 11 } },       // "STD 5" 8 columns
            { s: { r: 0, c: 12 }, e: { r: 0, c: 19 } },      // "STD 6" 8 columns
            { s: { r: 0, c: 20 }, e: { r: 0, c: 24 } },     // "STD 7" 5 columns
            { s: { r: 0, c: 25 }, e: { r: 0, c: 29 } },     // "STD 8" 5 columns
            { s: { r: 0, c: 30 }, e: { r: 0, c: 34 } },     // "STD 9" 5 columns
            { s: { r: 0, c: 35 }, e: { r: 0, c: 39 } },     // "STD 10" 5 columns
            { s: { r: 0, c: 40 }, e: { r: 0, c: 43 } },     // "CRW 5" 4 columns
            { s: { r: 0, c: 44 }, e: { r: 0, c: 46 } },     // "CRW 6" 3 columns
            { s: { r: 0, c: 47 }, e: { r: 0, c: 49 } },     // "CRW 7" 3 columns
            { s: { r: 0, c: 50 }, e: { r: 0, c: 52 } },     // "CRW 8" 3 columns
            { s: { r: 0, c: 53 }, e: { r: 0, c: 55 } },     // "CRW 9" 3 columns
            { s: { r: 0, c: 56 }, e: { r: 0, c: 58 } }      // "CRW 10" 3 columns
            // Add more entries if needed based on your actual data
        ];

        worksheet["!merges"] = adjustedMerges;

        worksheet["M1"].s = style_h2;
        XLSX.utils.sheet_add_aoa(worksheet, [["Fornitore", "Puerto de descarga", "Numero Contenedor ", "Marca",
            "40", "50", "60", "65", "70", "75", "80", "85",
            "40", "50", "60", "65", "70", "75", "80", "85",
            "65", "70", "75", "80", "85",
            "65", "70", "75", "80", "85",
            "65", "70", "75", "80", "85",
            "65", "70", "75", "80", "85",
            "60", "70", "75", "80",
            "70", "75", "80",
            "70", "75", "80",
            "70", "75", "80",
            "70", "75", "80",
            "70", "75", "80",
            "TOT", "BL", "Sigilo"
        ]], { origin: "A2" });

        var lastIndex = rows.length + 2;
        for (var r = 3; r <= lastIndex; r++) {
            worksheet["BH" + r] = { t: "n", v: 0, f: "=SUMIF(E" + r + ":BG" + r + ",\"<>\",E" + r + ":BG" + r + ")" };
            for (var c = 4; c < (columns.length - 3); c++) {
                var cell = columns[c] + (r);
                console.log(cell);
                worksheet[cell].z = "0;-0;;@";
                //worksheet[cell].f = "0;-0;;@";
                //worksheet[cell].w = "0;-0;;@";
            }
        }

        var formulas = [];
        for (var c = 4; c < (columns.length - 2); c++) {
            formulas.push({ t: "n", v: 0, f: "=SUMIF(" + columns[c] + "3:" + columns[c] + lastIndex + ",\"<>\" ," + columns[c] + "3:" + columns[c] + lastIndex + ")" });
        }
        XLSX.utils.sheet_add_aoa(worksheet, [formulas], { origin: "E" + (rows.length + 3) });

        worksheet['!autofilter'] = { ref: "A2:BJ2" };

        var wsrows = [];
        for (let i = 0; i < lastIndex; i++) {
            if (i == 0) {
                wsrows.push({ hpx: 15.75 })
            }
            else if (i == 1) {
                wsrows.push({ hpx: 36.75 })
            }
            else {
                wsrows.push({ hpx: 17.5 })
            }

        }
        worksheet['!rows'] = wsrows; // ws - worksheet

        var wscols = [];
        for (let i = 0; i < columns.length; i++) {
            if (i == 0) {
                wscols.push({ wch: 28.57 })
            }
            else if (i == 1) {
                wscols.push({ wch: 20 })
            }
            else if (i == 2) {
                wscols.push({ wch: 20.86 })
            }
            else if (i == 3) {
                wscols.push({ wch: 23.29 })
            }
            else if (i < 40) {
                wscols.push({ wch: 5 })
            }
            else if (i < 59) {
                wscols.push({ wch: 7 })
            }
            else if (i == 59) {
                wscols.push({ wch: 10 })
            }
            else if (i == 60) {
                wscols.push({ wch: 19.43 })
            }
            else if (i == 61) {
                wscols.push({ wch: 17.29 })
            }
            else {
                wscols.push({ wch: 8.43 })
            }

        }
        worksheet['!cols'] = wscols; // ws - worksheet

        for (var r = 0; r < (rows.length + 3); r++) {
            for (var c = 0; c < (columns.length); c++) {
                var cell = columns[c] + (r + 1);
                if (worksheet[cell] == null) {
                    continue;
                }
                if (c == 0) {
                    if (r == 0) {
                        /*worksheet[columns[c] + r]*/
                    }
                    else if (r == 1) {
                        worksheet[cell].s = style_h1;
                    }
                    else {
                        worksheet[cell].s = style_default;
                    }

                }
                else if (c == 1) {
                    if (r == 0) {
                        /*worksheet[columns[c] + r]*/
                    }
                    else if (r == 1) {
                        worksheet[cell].s = style_h1;
                    }
                    else {
                        worksheet[cell].s = style_default;
                    }
                }
                else if (c == 2) {
                    if (r == 0) {
                        /*worksheet[columns[c] + r]*/
                    }
                    else if (r == 1) {
                        worksheet[cell].s = style_h1;
                    }
                    else {
                        worksheet[cell].s = style_default;
                    }
                }
                else if (c == 3) {
                    if (r == 0) {
                        /*worksheet[columns[c] + r]*/
                    }
                    else if (r == 1 ) {
                        worksheet[cell].s = style_h1;
                    }
                    else {
                        worksheet[cell].s = style_default;
                    }
                }
                else if (c < 40) {
                    if (r < 2) {
                        worksheet[cell].s = style_h2;
                    } else {
                        worksheet[cell].s = style_default;
                    }
                }
                else if (c < 59) {
                    if (r < 2) {
                        worksheet[cell].s = style_h3;
                    } else {
                        worksheet[cell].s = style_default;
                    }
                }
                else if (c == 59) {
                    if (r == 1) {
                        worksheet[cell].s = style_h4;
                    } else {
                        worksheet[cell].s = style_default;
                    }
                }
                else if (c == 60) {
                    if (r == 1) {
                        worksheet[cell].s = style_h1;
                    } else {
                        worksheet[cell].s = style_default;
                    }
                }
                else if (c == 61) {
                    if (r == 1) {
                        worksheet[cell].s = style_h1;
                    } else {
                        worksheet[cell].s = style_default;
                    }
                }
                else {
                    worksheet[cell].s = style_default;

                }

            }
        }

        /* create an XLSX file and try to save to Presidents.xlsx */
        XLSX.writeFile(workbook, "ReporteDespacho_" + semana.nombre +".xlsx", { compression: true });
    }
}